
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import BacMultiselectWrapper from '@/components/BacMultiselectWrapper.vue'
import BacButton from '@/components/BacButton.vue'
import BacInput from '@/components/BacInput.vue'
import { RallyRound } from '../../../lib/models/RallyRound'
import { User } from '../../../lib/models/User'
import UIkit from 'uikit'
import Multiselect from 'vue-multiselect'
import { Rally } from '../../../lib/models/Rally'

@Component({
  components: {
    BacModal,
    BacButton,
    BacInput,
    BacMultiselectWrapper,
    Multiselect
  }
})
export default class CustomerPermissionsModal extends Vue {
  @Prop({ default: -1 }) editedCustomerId!: number
  @Prop({ default: () => [] }) allRallyRounds!: RallyRound[]
  @Prop({ default: () => [] }) users!: User[]

  newCustomerGroupId = -1
  selectedPermissionRallyRounds = []
  selectedCrewRallyRounds = []

  stagedCrewRallyRound = 0
  stagedCrewTask = ''

  User = User

  get editedUser () {
    return this.users.find(user => user.id === this.editedCustomerId) ?? new User()
  }

  mounted () {
    this.onEditedUserChange()
  }

  @Watch('$store.state.Rally.rallies')
  onAllRallyRoundsChange () {
    this.remapMultiselectOptions()
  }

  @Watch('editedCustomerId')
  onEditedUserChange () {
    this.remapMultiselectOptions()
  }

  remapMultiselectOptions () {
    this.selectedPermissionRallyRounds = this.allRallyRounds.filter(rallyRound => {
      return this.editedUser.rallyRoundPermissions.find(rallyRoundPermission => {
        return (rallyRoundPermission as any).rally_round_id === rallyRound.id
      })
    }) as any

    this.selectedCrewRallyRounds = this.$store.getters.rallyRounds.filter((rallyRound: RallyRound) => {
      return this.editedUser.crew.find(crew => {
        return (crew as any).rally_round_id === rallyRound.id
      })
    }) as any
  }

  addToCrew () {
    (this.editedUser.crew as any).push({ // eslint-disable-next-line
      rallyRoundId: this.stagedCrewRallyRound,
      task: this.stagedCrewTask
    })
    this.remapMultiselectOptions()
  }

  removeCrew (i: number) {
    this.editedUser.crew.splice(i, 1)
    this.remapMultiselectOptions()
  }

  async updateEditedUserPermissions () {
    await this.editedUser.updatePermissions(
      this.editedUser.customerGroupId,
      this.selectedPermissionRallyRounds.map(rallyRound => (rallyRound as any).id),
      this.editedUser.crew
    )
    UIkit.notification({
      message: 'Berechtigungen gespeichert!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}
